// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.submenu-background[data-v-1a1fd423] {\n    width: 100%;\n    background-color: rgba(255, 255, 255, 30%);\n    backdrop-filter: blur(5px);\n    z-index: 1;\n}\n.card-gap[data-v-1a1fd423] {\n    display: flex;\n    flex-direction: column;\n    gap: 24px !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
